import { QuarterlyReport } from '../../types/reports';
import { ReportStatusCard } from '../common/ReportStatusCard';
import { mapReportStatus } from '../../utils/statusUtils';

interface ReportListCardProps {
  report: QuarterlyReport;
  viewOnly?: boolean;
  onSubmit: (reportId: string) => void;
  onView: (reportId: string) => void;
  onUpdate: (reportId: string) => void;
}

export function ReportListCard({
  report,
  viewOnly,
  onSubmit,
  onView,
  onUpdate,
}: Readonly<ReportListCardProps>) {
  return (
    <ReportStatusCard
      id={report.id}
      title={report.title}
      subtitle={report.subtitle}
      dueDate={report.dueDate}
      status={mapReportStatus(report.status, report.dueDate)}
      isInProgress={report.isInProgress}
      viewOnly={viewOnly}
      onSubmit={onSubmit}
      onView={onView}
      onUpdate={onUpdate}
    />
  );
} 